
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

/**
 * Doesn't get stuck when event loop is blocked
 */
@Component({})
export default class LoadingSpinner extends Vue {
  @Prop({ default: 4 })
  width!: number;

  @Prop({ required: true })
  color!: string;

  @Prop({ default: 100 })
  size!: number;

  get outerDivStyles() {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`
    };
  }

  get innerDivStyles() {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`,
      margin: `${this.width}px`,
      "border-width": `${this.width}px`,
      "border-top-color": this.color
    };
  }
}
